import User from 'uscc-services/lib/model/User';
import CovidStatus from 'uscc-services/lib/model/CovidStatus';
import axios, { AxiosAdapter } from 'axios'
const { apiEndpoint, apiKey, authEndpoint } = require('config')

const cookie = require('cookie')

export const getCognitoUserInfo: any = () => {
  try {
    const cookies = cookie.parse(document.cookie) || {}
    const { id_token } = cookies;
    if (id_token !== undefined ) {
      const userInfoString = Buffer.from(id_token.split('.')[1], 'base64').toString('utf8') || '{}'
      const userInfo = JSON.parse(userInfoString)
      return userInfo
    } else {
      return null
    }
  } catch(err) {
    console.log(err)
    return null
  }
}

export const getUserInfo: any = () => {
  try {
    const cookies = cookie.parse(document.cookie) || {}
    const { id_token } = cookies
    const userInfoString = Buffer.from(id_token.split('.')[1], 'base64').toString('utf8') || '{}'
    const userInfo = JSON.parse(userInfoString)
    const user: any = {
      firstName: userInfo.name,
      lastName: userInfo.family_name,
      agreesToTerms: true,
      covidStatus: CovidStatus.NOT_REPORTED,
      name: userInfo.name,
      type: ''
    }
    return user
  } catch(err) {
    return null
  }
}

export const getGroups = () => {
  try {
    const cookies = cookie.parse(document.cookie) || {}
    const { id_token = 'e30K' } = cookies
    const userInfoString = Buffer.from(id_token.split('.')[1], 'base64').toString('utf8') || '{}'
    const userInfo = JSON.parse(userInfoString)
    const groups: Array<any> = userInfo['cognito:groups'] || []
    return groups
  } catch(err) {
    return []
  }
}

export const getAuthHeader = () => {
  try {
    const cookies = cookie.parse(document.cookie) || {}
    const { id_token = '' } = cookies
    return id_token
  } catch(err) {
    console.log(err)
    return ''
  }
}

export const hasIdToken = () => {
  const cookies = cookie.parse(document.cookie) || {}
  const { id_token } = cookies
  return typeof id_token !== undefined
}

const stdHeaders = {
  'Authorization': getAuthHeader(),
  'x-api-key': apiKey
}

export async function request(options: any): Promise<Object> {
  if(hasIdToken()) {
    options.headers = options.headers || {}
    options.headers = Object.assign(stdHeaders, options.headers)
    const newOptions = Object.assign({}, options, {
      url: `${apiEndpoint}/${options.path}`,
      headers: Object.assign({}, options.headers || {}, stdHeaders),
      path: undefined
    })
    const result = await axios(newOptions)
    return result
  } else {
    await axios({
      method: 'GET',
      url: `${authEndpoint}/refresh`,
      withCredentials: true
    })
    return await request(options)
  }
}

export default {
  getUserInfo,
  getGroups,
  getAuthHeader,
  request,
  getCognitoUserInfo
}